/** Пути в одном месте: их знают и роутер, и переходы из фич. */
export const ROUTES = {
  root: '/',
  onboarding: '/onboarding',
  /** Вход в веб-версии — гостю, дошедшему до того, что открыто только после входа (см. WEB.md). */
  login: '/login',
  home: '/home',
  chat: '/chat',
  /** Карусель выбора собеседника перед стартом разговора — общая для свободной практики и ролевых игр. */
  tutorSelect: '/tutor-select',
  /** Экран-превью ролевой игры (заголовок, сцена, «Ваши цели») перед стартом разговора — `/roleplay/:id`. */
  roleplay: '/roleplay',
  /** Экран-детали идиомы (перевод, пример, «Начать диалог») — `/idiom/:id`. */
  idiom: '/idiom',
  /** Полный список ролевых игр (со статус-фильтром) — вход по кнопке «Показать ещё» из `widgets/topics`, когда выбран фильтр «Ролевые игры». */
  roleplayAll: '/topics/roleplay',
  /** Полный список идиом (со статус-фильтром) — вход по кнопке «Показать ещё» из `widgets/topics`, когда выбран фильтр «Идиомы». */
  idiomAll: '/topics/idiom',
  mistakes: '/mistakes',
  /** История прошлых разговоров — список, вход с кнопки «Предыдущие беседы» на главном экране. */
  history: '/history',
  /** Хаб «Словари»: Готовые/Мои словари, вход в «Учить»/«Повторять» — вкладка, вторая в `TabBar`. */
  vocabulary: '/vocabulary',
  /** «Учить»/«Повторять» — отдельные экраны поверх словаря, без нижних табов. */
  vocabularyLearn: '/vocabulary/learn',
  vocabularyReview: '/vocabulary/review',
  /** Управление «Моими словарями» (создать/переименовать/удалить/открыть) — отдельная страница поверх словаря, вход по карандашу в `MyListsSection`. */
  vocabularyLists: '/vocabulary/lists',
  statistics: '/statistics',
  /** Якорь блока «Уровень языка» на «Аналитике» — сюда возвращает проверка уровня. */
  statisticsLevelAnchor: 'level',
  /** Повторная проверка уровня — вход из блока «Уровень языка» на «Аналитике», поверх без нижних табов. */
  levelCheck: '/level-check',
  profile: '/profile',
  /** «Персонализация»: тумблер, цели, интересы и «База знаний» — вход из профиля. */
  personalization: '/personalization',
  /** Редактор интересов (тот же список, что и в онбординге) — подраздел «Персонализации». */
  personalizationInterests: '/personalization/interests',
  /** Редактор целей (тот же вопрос, что и в онбординге) — подраздел «Персонализации». */
  personalizationGoal: '/personalization/goal',
  /** «База знаний» — вся собранная о человеке память, вход из «Персонализации». */
  memory: '/memory',
  settings: '/settings',
  /** «Подписка»: состояние, автопродление и последние платежи — вход из профиля. */
  subscription: '/subscription',
  /** Пейволл отдельным экраном — вход с баннера «Премиум» в профиле. */
  premium: '/premium',
  /** Детали одного платежа — `/subscription/payments/:id`. */
  subscriptionPayment: '/subscription/payments',
  /**
   * «Документы»: список, а `/documents/:id` — сам документ (оферта, политика,
   * согласие) внутри мини-аппа. Открываются и до онбординга — туда ведут
   * ссылки с его первого шага.
   */
  documents: '/documents',
  /** Стенд говорящего 3D-аватара — только dev, в навигации нет (см. `pages/avatar-lab`). */
  avatarLab: '/avatar-lab',
  /** Стенд распознавания речи — только dev, в навигации нет (см. `pages/stt-lab`). */
  sttLab: '/stt-lab',
} as const;
